import { memo } from 'react';
import { motion } from 'framer-motion';

import { useGetParams } from '../../hooks/useGetParams';

import { BgVideo } from '../BgVideo/BgVideo';

import styles from './Advt.module.css';

export const Advt = memo(() => {
  const { title, qrCode1, qrCode2, titleFontSize, sizeQR } = useGetParams();

  const wordsTitle = title?.split(' ') || [];

  return (
    <div className={styles.advtBlock}>
      {wordsTitle && (
        <div
          className={styles.title}
          // style={{ fontSize: `${titleFontSize}rem` }}
        >
          {wordsTitle[0] && (
            <motion.div
              style={{ fontSize: '9.375rem' }}
              initial={{ scale: 0, color: '#A2D9F7' }}
              animate={{ scale: 1, color: ['#A2D9F7', '#008DD2', '#ffffff'] }}
              transition={{
                color: {
                  delay: 1.4,
                  duration: 0.6,
                  ease: ['easeIn', 'easeIn'],
                },

                scale: {
                  duration: 0.68,
                  delay: 1.4,
                  ease: 'easeIn',
                },
              }}
            >
              {wordsTitle[0]}
            </motion.div>
          )}

          <div className={styles.titleLine2} style={{ fontSize: '12.5rem' }}>
            {wordsTitle.slice(1).map((w, idx) => (
              <motion.div
                key={w + idx}
                initial={{ scale: 0, color: '#A2D9F7' }}
                animate={{ scale: 1, color: ['#A2D9F7', '#008DD2', '#ffffff'] }}
                transition={{
                  color: {
                    delay: 1.4 + 0.5 + idx * 0.5,
                    duration: 0.6,
                    ease: ['easeIn', 'easeIn'],
                  },

                  scale: {
                    duration: 0.68,
                    delay: 1.4 + 0.5 + idx * 0.5,
                    ease: 'easeIn',
                  },
                }}
              >
                {w}
              </motion.div>
            ))}
          </div>
        </div>
      )}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.15, 1] }}
            transition={{
              duration: 1.48,
              ease: 'easeInOut',
              times: [0, 0.85, 1],
            }}
            className={styles.qrCode}
          >
            <img
              src={qrCode1}
              alt="QR"
              style={{
                height: `${sizeQR}rem`,
                width: `${sizeQR}rem`,
              }}
            />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.15, 1] }}
            transition={{
              duration: 1.48,
              ease: 'easeInOut',
              times: [0, 0.85, 1],
            }}
            className={styles.qrCode}
          >
            <img
              src={qrCode2}
              alt="QR"
              style={{
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            />
          </motion.div>
        )}
      </div>

      <BgVideo />
    </div>
  );
});
